export function isEmpty(object, { except = [] } = {}) {
    if (except.length > 0 && except.includes(typeof object)) return true;

    if (typeof object === "string") return object.length <= 0;
    if (!object || typeof object !== "object") return true;

    if (Array.isArray(object)) return object.length <= 0;

    return Object.keys(object).length <= 0;
}

export function mapFields(data, field) {
    if (!data) return null;

    return data.map((element) => element[field]?.toString());
}

export function compare(first, second) {
    return JSON.stringify(first) === JSON.stringify(second);
}

export function comparerArrObj(otherArray, campo) {
    return function (current) {
        return (
            otherArray.filter(function (other) {
                return other[campo] === current[campo];
            }).length === 0
        );
    };
}

export function search(object, value) {
    if (!object || !value || typeof value !== "string") return object;

    return object.filter((item) => {
        return Object.values(item).some((element) => {
            return (
                String(element).toLowerCase().indexOf(value.toLowerCase()) !==
                -1
            );
        });
    });
}
